import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { InvoiceDelegate } from "../InvoiceService/invoice.delegate";
import { InvoiceService } from "../InvoiceService/invoice.service";

export class InvoiceServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): InvoiceService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new InvoiceDelegate(httpProvider);

        return new InvoiceService(delegate, authenticationService);
    }
}